export default __webpack_public_path__ + "static/media/dockbit.8ad41c15.svg";